module.exports = __webpack_public_path__ + "media/images/icons/facebook-light-75396d5e97d45771747421e19d8e417d.png";